import { useIsSplitEnabled } from '@buffer-mono/features'

const COMPOSER_ZUSTAND_EDIT_POST_FLAG = 'composer-zustand-edit-post'

/**
 * Kill-switch for the edit-path read-flip. Separate from
 * `composer-zustand-create-post`: a stale variant read on edit can send
 * explicit-null clears that delete stored data, so it gets its own ramp.
 */
export function useEditPostZustandEnabled(): boolean {
  return useIsSplitEnabled(COMPOSER_ZUSTAND_EDIT_POST_FLAG)
}
